export const NAME = 'CREATE_KEY';

export const FREE_PASS = 0;
export const GUEST_VISITOR = 1;
export const GUEST_WORKER = 2;
